export const toLookerQuery = (query) => ({
    ...query,
    fields: Array.isArray(query.fields) ? query.fields : Object.keys(query.fieldMap || {})
});
//# sourceMappingURL=query.js.map